<template>
  <div>
    <div class="row page-title">
      <label class="Agency-Name-HFM-Co"
        >{{ ReportingEntityRequestDetail.SuggestedEntity }} - Reporting Entity Request</label>
    </div>
    <div class="row icreview-component">
      <b-card class="col-lg-9 main-content">
          <reporting-entity-overview :ReportingEntityRequestDetail = ReportingEntityRequestDetail></reporting-entity-overview>
      </b-card>
      <div class="col-lg-3 approval-side-section">
        <div class="row">
          <b-alert :show="!IsApproveOrRejectEnabled && ReportingEntityRequestDetail.Id > 0" class="alert-info-new position-fixed fixed-top m-0 rounded-0" variant="info" dismissible>
              The Request is already approved or rejected.
          </b-alert>
          <p class="approve-reject-label">
            Approve or Reject Reporting Entity Request
          </p>
          <p class="approve-reject-content">
          <span v-if="IsCompletionRequest">
            Complete or Reject Reporting Entity Request
          </span>
          <span v-else>
            When approved, this request will be sent to
            <template v-if="ReportingEntityRequestDetail.Status === 'Finance Director Approval'">
              Financial Systems Director Approval.
            </template>
            <template v-else-if="ReportingEntityRequestDetail.Status === 'Financial Systems Director Approval'">
              TM1 Admin.
            </template>
          </span>
        </p>
        <div class="text-right" style="width: 100%">
          <button v-if="IsApproveOrRejectEnabled" class="btn custom-button btn-primary" @click="Approve()">
            {{ IsCompletionRequest ? 'Complete' : 'Approve' }}
          </button>
          <button v-else class="btn custom-button btn-primary" disabled="disabled" title="The request is already approved or rejected.">
            {{ IsCompletionRequest ? 'Complete' : 'Approve' }}
          </button>
        </div>
        </div>
        <div class="row reject-section">
          <label class="rejection-label">Rejection Comments</label>
          <b-textarea
            class="rejection-comments"
            placeholder="Enter Rejection Comments"
            v-model="Comments"
            v-bind:class="{
              errorborder: displaycommentserror && showCommentsError,
              noterrorborder: !displaycommentserror || !showCommentsError,
            }"
            @blur="SetDirty()"
            @focus="ResetDirty()"
            rows="5"
          >
          </b-textarea>
          <div class="error-message-format required-field" v-if="displaycommentserror && showCommentsError">
            Required field
          </div>
          <div class="text-right" style="width: 100%; padding-top: 10px">
              <button  v-if="IsApproveOrRejectEnabled" class="btn custom-button btn-outline-primary" @click="Reject()">
                Reject
              </button>
              <button v-else class="btn custom-button btn-outline-primary" disabled="disabled" title="The request is already approved or rejected.">
                Reject
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scope >
@media screen and (min-width: 1200px) {
  .icreview-component {
    padding: 1rem 3rem 0px !important;
    height: 600px !important;
  }
}
.Agency-Name-HFM-Co {
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.73px;
  color: #4d5161;
}
.approval-side-section {
  background-color: rgba(162, 169, 173, 0.05);
  margin-bottom: 2px;
  padding-right: 35px !important;
  -webkit-box-shadow: 0 1px 3px 0 rgb(9 30 66 / 12%);
  box-shadow: 0 1px 3px 0 rgb(9 30 66 / 12%);
  border: solid 1px rgba(239, 242, 244, 0.2);
  border-left: none;
  border-radius: 0px 8px 8px 0px;
}
.row.page-title {
  height: 55px;
  background-color: #eef3f5 !important;
}
.row.page-title > label {
  padding: 14px 0px 14px 55px !important;
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.81px;
  color: #4d5161;
  text-transform: none !important;
}
.panel-list:not(.media-dropdowns) {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.panel-list .panel-body .panel-title {
  border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  width: 100%;
  margin-left: 0px;
  margin-bottom: 25px !important;
}
.panel-list .panel-body .panel-title label {
  color: #77a2bb;
  margin-bottom: 0px !important;
  padding-top: 13px !important;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.57;
  letter-spacing: normal;
  padding-left: 0px !important;
  min-height: 35px;
}
.panel-list .panel-body .panel-title .btn {
  padding-left: 5px;
  padding-right: 5px;
}
.panel-list .panel-body .panel-title > div {
  padding-right: 0px !important;
  float: right;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.75;
  letter-spacing: normal;
  color: #00a1d2;
}
.panel-list .panel-content label {
  text-transform: uppercase;
  color: #2c3865;
  font-size: 12px;
  margin-bottom: 1px !important;
  padding-left: 0px;
}
.panel-list .panel-content p {
  text-transform: uppercase;
  color: #4d5161;
  font-size: 14px;
  font-weight: 600;
}
.panel-list > .panel-body {
  margin-top: 1rem !important;
}
</style>

<script>
import store from "@/store";
import { required } from "vuelidate/lib/validators";
import ReportingEntityOverview from "@/components/ReportingEntity/Overview";
import * as ReportingEntityRequestStatus from "../../utilities/ReportingEntityWorkflowStates";
export default {
  name: 'ApprovalLevel',
  components: {
    "reporting-entity-overview": ReportingEntityOverview
  },
  validations: {
    Comments: {
      required,
    },
  },
  data() {
    return {
      displaycommentserror: false,
      ReportingEntityRequestDetail:{},
      Error: false,
      Comments: "",
      showCommentsError: false,
    };
  },

  mounted() {
    if (this.canApproveReportingEntityRequestLevel1  || this.canApproveReportingEntityRequestLevel2 || this.canCompleteReportingEntityRequest) {
        this.GetReportingEntityRequestWithTaskDetails();
    }
    else {
      this.$router.push({
        name: "error",
        params: { message: "UnAuthorized" },
      });
    }
  },
  computed: {
    IsCompletionRequest() {
      return this.ReportingEntityRequestDetail.Status === 'Completion';
    },
    IsApproveOrRejectEnabled() {
      return (
        (this.canApproveReportingEntityRequestLevel1 && this.ReportingEntityRequestDetail.Status==ReportingEntityRequestStatus.FinanceDirectorApproval)
        || (this.canApproveReportingEntityRequestLevel2 && this.ReportingEntityRequestDetail.Status==ReportingEntityRequestStatus.FinancialSystemsDirectorApproval)
        || (this.canCompleteReportingEntityRequest && this.ReportingEntityRequestDetail.Status==ReportingEntityRequestStatus.PendingCompletionStates)
      );
    },
    canApproveReportingEntityRequestLevel1() {
      return this.$store.getters.canApproveReportingEntityRequestLevel1;
    },
    canApproveReportingEntityRequestLevel2() {
      return this.$store.getters.canApproveReportingEntityRequestLevel2;
    },
    canCompleteReportingEntityRequest() {
      return this.$store.getters.canCompleteReportingEntityRequest;
    },
  },
  props: ["id"],

  methods: {
    SetDirty() {
      if (this.Comments.length > 0) {
        this.showCommentsError = false;
      } else {
        this.showCommentsError = true;
      }
    },
    ResetDirty() {
      this.showCommentsError = false;
    },
    GetData() {
      return {
        ID: parseInt(this.id),
        Comments: this.Comments,
        ActiveTaskID: this.ReportingEntityRequestDetail.ActiveTaskID,
        ProjectID: this.ReportingEntityRequestDetail.OmniflowProjectID,
        ProcessID: this.ReportingEntityRequestDetail.OmniflowProcessID,
      };
    },

    Approve() {
      this.$store
        .dispatch("reportingEntity/ApproveRequest", this.GetData())
        .then(() => {
          store.dispatch(
            "progress/setSuccessMessage",
            `The ${this.ReportingEntityRequestDetail.SuggestedEntity} Reporting Entity Request has been approved.`
          );
          this.$router.push("/ReportingEntity");
        })
        .catch((ex) => {
          if (ex.response) {
            this.SetErrorMessage(
              "Error while approving request",
              ex.response.data
            );
          } else {
            this.SetErrorMessage("Error while approving request", ex);
          }
        });
    },

    Reject() {
      if (this.Comments.length > 0) {
        this.displaycommentserror = false;
        this.$store
          .dispatch("reportingEntity/RejectRequest", this.GetData())
          .then(() => {
            store.dispatch(
              "progress/setSuccessMessage",
              `Reporting Entity Request for ${this.ReportingEntityRequestDetail.SuggestedEntity} has been rejected`
            );
            this.$router.push("/ReportingEntity");
          })
          .catch((ex) => {
            if (ex.response) {
              this.SetErrorMessage(
                "Error while rejecting request",
                ex.response.data
              );
            } else {
              this.SetErrorMessage("Error while rejecting request", ex);
            }
          });
      } else {
        this.displaycommentserror = true;
        this.showCommentsError = true;
      }
    },

    SetErrorMessage(message, ex) {
      store.dispatch(
        "progress/setErrorMessage",
        `${message}. The error is ${ex}`
      );
    },

    GetReportingEntityRequestWithTaskDetails() {
      var inputObj = {
                id: parseInt(this.id),
                isEdit: false,
            };
      this.$store
        .dispatch(
          "reportingEntity/GetReportingEntityRequestWithTaskDetails",
          inputObj
        ).then((res) => {
          this.ReportingEntityRequestDetail = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 403) {
            this.$router.push({
              name: "error",
              params: {
                message: "UnAuthorized"
              },
            });
          }
          else{
            this.Error = true;
            alert(err);
          }
        });
    },
  },
};
</script>